// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"icon-link__button--fZmaF","buttonText":"icon-link__buttonText--SHMoU","buttonIcon":"icon-link__buttonIcon--2Jgwu"};